
  <div class="filter-container">
    <form [formGroup]="byIdForm" (ngSubmit)="apply()">
      <div class="title">
        <label>ID:</label>
      </div>

      <div formArrayName="ids">
        <div class="sgc" *ngFor="let idCtrl of ids.controls; let i = index">
          <input
            type="number"
            [formControl]="idCtrl"
            (click)="setEditingIndex(i)"
            min="1"
          />
        </div>
      </div>

      <button type="button" class="add-id-btn" (click)="addIdField()">+</button>

      <not
        [filter]="byIdFilter"
        (filterChanged)="onFilterChanged($event)"
      ></not>

      <button class="apply-filter-btn" type="submit">Apply</button>
    </form>
  </div>
